import { useFetchPayment } from './useFetchPayment'
import { useQueryClientUtils } from '../useQueryClientUtils'
import { queryKeys as balanceQueryKeys } from '../balance/useQueryBalance'

const create = () => {
  const { create } = useFetchPayment()
  const { invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: create,
    onSuccess: (_, variables) => {
      invalidateQueries([balanceQueryKeys.all(variables).queryKey])
    },
  })
}

export const useMutationPayment = {
  create,
}
